import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '~/components/PageTitle';
import {
  Container,
  Button,
  TextField,
} from '~/components/_layouts/forms/styles';
import { updateUserInfo } from '~/api';
import { profileRequest } from '~/store/modules/user/actions';
import Loading from '~/components/Loading';

function Profile() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);

  const [userName, setUsername] = useState(user.name);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const toggleEditProfile = () => {
    setIsEditing(!isEditing);
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    event.preventDefault();
    await updateUserInfo(user.id, { name: userName });
    await dispatch(profileRequest());
    setIsLoading(false);
    setIsEditing(!isEditing);
  };

  return (
    <>
      <PageTitle>Perfil do usuário</PageTitle>
      <Container>
        <form className="profile" onSubmit={(event) => handleSubmit(event)}>
          {!isEditing ? (
            <>
              <h2>Nome: {user.name}</h2>
              <h2>E-mail: {user.email}</h2>
              <Button fullWidth onClick={toggleEditProfile}>
                Editar perfil
              </Button>
            </>
          ) : (
            <>
              <h2>Nome:</h2>
              <TextField
                fullWidth
                label="Nome"
                defaultValue={user.name}
                value={userName}
                variant="outlined"
                onChange={(event) => setUsername(event.target.value)}
              />

              <h2>E-mail: {user.email}</h2>
              <div style={{ display: 'flex' }}>
                <Button
                  fullWidth
                  disabled={isLoading}
                  onClick={toggleEditProfile}
                  cancelButton
                >
                  Cancelar
                </Button>
                <Button disabled={isLoading} fullWidth type="submit">
                  Salvar
                  {isLoading && <Loading buttonLoading />}
                </Button>
              </div>
            </>
          )}
        </form>
      </Container>
    </>
  );
}

export default Profile;
